<template>
  <div :class="{ error: error }" class="cb-select">
    <label :for="id" class="sr-only">{{ label }}</label>
    <select
      @blur="updateFocus('blur')"
      @focus="updateFocus('focus')"
      @change="updateValue($event.target.value)"
      ref="select"
      :id="id"
      class="cb-select__input"
    >
      <option disabled selected value="">{{ label }}</option>
      <option
        v-for="(question, index) in options"
        :value="question"
        :key="index"
      >
        {{ question }}
      </option>
    </select>
    <div class="cb-select__arrow"><img alt src="../../assets/icons/select-icon.svg">
    </div>
    <div class="cb-select__error-bar"></div>
    <span class="sr-only">{{ errorText }}</span>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
    updateFocus(event) {
      if (event === 'blur') this.$emit('blur');
      if (event === 'focus') this.$emit('focus');
    },
  },
};
</script>

<style lang="scss">
.cb-select {
  position: relative;

  &__input {
    border: none;
    width: 100%;
    background-color: $lighter-grey;
    font-size: 16px;
    color: #000;
    line-height: 22px;
    padding: 13px 34px 13px 13px;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;

    &::-ms-expand {
      display: none;
    }
  }

  &__error-bar {
    position: absolute;
    background-color: $dark-red;
    transition: background-color 0.2s ease-in;
    height: 100%;
    width: 5px;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &__arrow {
    position: absolute;
    height: 6px;
    width: 10px;
    right: 19px;
    top: 50%;
    transform: translateY(-50%);

    img {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  &.error {
    .cb-select {
      &__error-icon,
      &__error-bar {
        opacity: 1;
      }

      &__input {
        color: $dark-red;
      }
    }
  }
}
</style>
